import { createContext, useContext, useState, useEffect } from 'react';
import { fetchAbout, getImageUrl } from '../services/api';

const AboutContext = createContext(null);

export function AboutProvider({ children }) {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    fetchAbout()
      .then(res => setAbout(res?.data?.attributes ?? null))
      .catch(() => setAbout(null));
  }, []);

  return (
    <AboutContext.Provider value={about}>
      {children}
    </AboutContext.Provider>
  );
}

export function useAbout() {
  return useContext(AboutContext);
}

export function useAboutSocials() {
  const a = useContext(AboutContext);
  return {
    github:    a?.social_github    || null,
    linkedin:  a?.social_linkedin  || null,
    twitter:   a?.social_twitter   || null,
    instagram: a?.social_instagram || null,
    facebook:  a?.social_facebook  || null,
  };
}

export function useAboutAvatar() {
  const a = useContext(AboutContext);
  return a ? getImageUrl(a.avatar) : null;
}
